<script>
import { createEventDispatcher } from "svelte";
const dispatch = createEventDispatcher();

//
// Component props
//

export let isLoginError = false;

//
// Component state
//

let groupId = '';

//
// Event handlers
//

function onSubmit(event) {
    dispatch('submit', groupId);
}

</script>

<article class="card">
    <h2>Login</h2>
    {#if isLoginError}
        <p class="error-msg">Woops! It looks like that group ID isn't correct. Please try again.</p>
    {/if}
    <p>Please enter your group ID</p>
    <input bind:value="{groupId}" type="text" />
    <p><button class="pure-button button-primary button-round" on:click={onSubmit} >Login</button></p>
</article>

<style>
.error-msg {
    background-color: #FFCCCC;
    color: #000;
    border-radius: 2px;
    padding: 2px;
}
</style>
